import { useHistory } from 'react-router-dom';
import './index.scss';
function XacThucLayout(props: any) {
    const history = useHistory();
    return (
        <div className='xac-thuc'>
            <div className="context">
                <div className="container" id="container">
                    <div className="container-left">
                        <div className="container-left--background">
                            <img className="container-left--image" src="./images/login/device.png" alt="bg" />
                        </div>
                        <div className="container-left--description">
                            <h2><b className='pointer' onClick={() =>  history.push('/')}>Học Hiệu Quả</b>, xin chào bạn!</h2>
                            <h3>Đăng ký tài khoản ngay để học miễn phí</h3>
                            <h4  className='pointer' onClick={() =>  history.push('/')}>Để trải nghiệm vui lòng click vào đây</h4>
                        </div>
                        <img className="container-left--image" src="./images/login/device.png" alt="bg" />
                    </div>
                    <div className="container-right">
                        {props.children}
                    </div>
                </div>
            </div>
            <div className="area" >
                <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div >
        </div>
    );
}
export default XacThucLayout;